import request from '@/utils/request'

const TemplateURL = {
  Add: '/template/create',
  List: '/template/list',
  Detail: '/template/view',
  update: '/template/update',
  Delete: '/template/delete',
  updateState: '/template/update-state',
  FieldList: '/template/field-list',
}

// 模板字段列表
export function fieldListTemplate (data) {
  return request({
    url: TemplateURL.FieldList,
    method: 'post',
    data
  })
}

// 模板列表
export function listTemplate (data) {
  return request({
    url: TemplateURL.List,
    method: 'post',
    data
  })
}

// 模板更新
export function updateTemplate (data) {
  return request({
    url: TemplateURL.update,
    method: 'post',
    data
  })
}

// 模板更新状态
export function updateStateTemplate (data) {
  return request({
    url: TemplateURL.updateState,
    method: 'post',
    data
  })
}

// 模板详情
export function detailTemplate (data) {
  return request({
    url: TemplateURL.Detail,
    method: 'post',
    data
  })
}

// 模板创建
export function createTemplate (data) {
  return request({
    url: TemplateURL.Add,
    method: 'post',
    data
  })
}

// 模板删除
export function deleteTemplate (data) {
  return request({
    url: TemplateURL.Delete,
    method: 'post',
    data
  })
}

// 字段列表
export function filedListTemplate (data) {
  return request({
    url: '/fields/list',
    method: 'post',
    data
  })
}

// 字段状态变更
export function updateStateFields (data) {
  return request({
    url: '/fields/update-state',
    method: 'post',
    data
  })
}

// 字段添加
export function createFields (data) {
  return request({
    url: '/fields/create',
    method: 'post',
    data
  })
}

// 字段编辑
export function updateFields (data) {
  return request({
    url: '/fields/update',
    method: 'post',
    data
  })
}

export default {
  listTemplate,
  detailTemplate,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  fieldListTemplate,
  updateStateTemplate,
  filedListTemplate,
  updateStateFields,
  createFields,
  updateFields
}
